import {useEffect, useState} from 'react';
import {apis} from '../services/alm';
import {constants} from '../assets/constants/constants';
import useAlmCorporateStatus from "./useAlmCorporateStatus";

const useGetEnrolled = () => {
  const [tagsData, setTagsData] = useState<any>([]);
  useAlmCorporateStatus();
  useEffect(() => {
    getAllEnrolled();
  }, []);
  const getAllEnrolled = async () => {
    try {
      const finalResult = [];
      const response: any = await apis.fetchAllEnrolled();
      finalResult.push(response.data);
      let isTrue = response?.links?.next;
      while (isTrue) {
        const res: any = await apis.nextBaseUrl(isTrue);
        finalResult.push(res.data);
        isTrue = res?.links?.next ? res?.links?.next : false;
      }
      const completedData = finalResult.flat(1)?.filter((res: any) => {
        return res?.attributes?.state === constants.COMPLETED;
      });
      const enrolledProgramId = completedData?.map((res: any) => {
        return res?.relationships?.learningObject?.data?.id;
      });
      const tags = response?.included?.filter((res: any) => {
        return enrolledProgramId.includes(res?.id);
      });
      setTagsData(tags || []);
    } catch (e) {
      console.error(e);
    }
  };
  return {tagsData};
};
export default useGetEnrolled;
